import { render } from "./OrganizationSettingsDetailDialog.vue?vue&type=template&id=a68d6886"
import script from "./OrganizationSettingsDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationSettingsDetailDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__